import UrlParameterInterface from '@repositories/UrlParameterInterface';
import AjaxService from '@services/AjaxService';

export default class CustomerTemplateRepository {
  private readonly ajaxService: AjaxService;

  public constructor(ajaxService: AjaxService) {
    this.ajaxService = ajaxService;
  }

  public create(attributes: any): Promise<any> {
    return this.ajaxService.postJson(
      '/api/desktop/customerTemplates/create',
      {data: {attributes}}
    );
  }

  public delete(customerTemplateId: number): Promise<any> {
    return this.ajaxService.sendDelete(
      `/api/desktop/customerTemplates/${customerTemplateId}`
    );
  }

  public getBlank(): Promise<any> {
    return this.ajaxService.getJson('/api/desktop/customerTemplates/blank');
  }

  public getCustomerTemplateData(customerTemplateId: number, parameters: UrlParameterInterface): Promise<any> {
    const url = `/api/customerTemplates/${customerTemplateId}`;
    return this.ajaxService.getJsonWithParameters(url, parameters);
  }

  public getCustomerTemplateExistsByCustomerNumber(parameters: UrlParameterInterface): Promise<any> {
    const url = '/api/customerTemplates/search-by-customernr';
    return this.ajaxService.getJsonWithParameters(url, parameters);
  }

  public getCustomerTemplates(parameters: UrlParameterInterface): Promise<any> {
    const url = '/api/customerTemplates';
    return this.ajaxService.getJsonWithParameters(url, parameters);
  }

  public loadCustomerTemplateOverview(customerTemplateId: number): Promise<any> {
    return this.ajaxService.getJson(`/api/desktop/customerTemplates/${customerTemplateId}`);
  }

  public reloadBasedata(customerTemplateId: number, attributes: any): Promise<any> {
    return this.ajaxService.postJson(
      `/api/desktop/customerTemplates/${customerTemplateId}/basedata/reload`,
      {data: {attributes}}
    );
  }

  public saveBankAccount(customerTemplateId: number, attributes: any): Promise<any> {
    return this.ajaxService.postJson(
      `/api/desktop/customerTemplates/${customerTemplateId}/bankAccount/save`,
      {data: {attributes}}
    );
  }

  public saveBasedata(customerTemplateId: number, attributes: any): Promise<any> {
    return this.ajaxService.postJson(
      `/api/desktop/customerTemplates/${customerTemplateId}/basedata/save`,
      {data: {attributes}}
    );
  }

  public saveInsuranceLegalExpenses(customerTemplateId: number, attributes: any): Promise<any> {
    return this.ajaxService.postJson(
      `/api/desktop/customerTemplates/${customerTemplateId}/insurances/legalExpenses/save`,
      {data: {attributes}}
    );
  }

  public saveInsuranceLiability(customerTemplateId: number, attributes: any): Promise<any> {
    return this.ajaxService.postJson(
      `/api/desktop/customerTemplates/${customerTemplateId}/insurances/liability/save`,
      {data: {attributes}}
    );
  }
}
